import React, { FC } from 'react';
import styles from './VerificationApproachOrganism.module.css';
import cn from 'classnames';
import { Button, Textarea, ValidationForm } from '../../atoms';
import { Form } from 'react-bootstrap';
import Radio from '../../atoms/Radio';

export interface VerificationApproachOrganismProps {
  content: string;
  setContent: (content: string) => void;
  published: boolean;
  setPublished: (published: boolean) => void;
  callbackFn: () => void;
}

const VerificationApproachOrganism: FC<VerificationApproachOrganismProps> = ({
  content,
  setContent,
  published,
  setPublished,
  callbackFn,
}) => {
  return (
    <div className={cn(styles.wrapper)}>
      <ValidationForm onSubmitCallback={callbackFn}>
        <Form.Group className="mb-3">
          <Form.Label>Approach</Form.Label>
          <Textarea content={content} setContent={setContent} />
        </Form.Group>

        <Form.Group className="mb-3">
          <Form.Label>Is Published</Form.Label>
          <Radio defaultChecked={published} onChange={setPublished} />
        </Form.Group>
        <Button className={cn(styles.button)} variant="dark" type="submit">
          Save
        </Button>
      </ValidationForm>
    </div>
  );
};

export default VerificationApproachOrganism;
